module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/level-3_start-c14b0872de7f6c7f1354e01c929c6f03.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/level-3_start.png
// module id = 442
// module chunks = 2